import Sheet from "react-modal-sheet";
import { useCallback, useEffect, useRef, useState } from "react";
import css from "./SheetUrl.module.scss";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { useResizeObserver } from "@wojtekmaj/react-hooks";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const resizeObserverOptions = {};
const iconSize = 24;

type Props = {};

const SheetUrl = (props: Props) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setloading] = useState(true);
  const [contentType, setcontentType] = useState();
  const [contentUrl, setcontentUrl] = useState();
  const [scrollPosition, setscrollPosition] = useState([]);

  const sheetOptions = {
    snapPoints: [-60],
  };

  useEffect(() => {
    if (!isOpen) {
      setloading(true);
      // console.log("Sheet is closed");

      document.body.removeAttribute("data-sheet-url");
      document.body.removeAttribute("data-sheet-comment-id");

      const targetCommnetId = document.body.getAttribute(
        "data-sheet-comment-id"
      );
      if (targetCommnetId) {
      }
    }
  }, [isOpen]);

  const closeSheet = () => {
    setOpen(false);
  };

  // bodyのdata-sheet-url属性の変更を監視してシートを表示
  useEffect(() => {
    // bodyのdata-sheet-url属性の変更を監視
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(async (mutation) => {
        const sheetUrl = mutation.target.getAttribute("data-sheet-url");

        fetch(sheetUrl)
          .then((res) => {
            const contentType = res.headers.get("Content-Type");
            // console.log("Content-Type:", contentType);
            setcontentType(contentType);
          })
          .catch((error) => {
            console.error("Error:", error);
          });

        if (sheetUrl) {
          // console.log("SheetUrl:", {
          //   sheetUrl,
          //   contentType,
          // });

          setOpen(true);
          setcontentUrl(sheetUrl);
          // setiframe(false);
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-sheet-url"],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleIframeLoad = () => {
    console.log("Iframe loaded!");
    setloading(false);
  };

  const enableDownload = contentUrl?.indexOf("download=1") !== -1;

  const fileDownload = () => {
    try {
      const url = new URL(contentUrl);
      const searchParams = url.searchParams;
      const fileName = searchParams.get("name");

      console.log("Download:", fileName, contentUrl, url, searchParams);

      fileDownloadFromUrl(
        `${fileName || "参考資料"}.${mimeToExtension(contentType)}`,
        contentUrl
      );
    } catch (e) {
      console.error("Error:", e);
      alert("ダウンロードに失敗しました。");
    }
  };

  return (
    <>
      <Sheet isOpen={isOpen} onClose={closeSheet} {...sheetOptions}>
        <Sheet.Container>
          <Sheet.Header>
            <div className={`${css["sheetHeader"]}`}>
              <div>
                {enableDownload && (
                  <Button
                    variant="contained"
                    onClick={fileDownload}
                    sx={{
                      fontSize: 14,
                    }}
                  >
                    ダウンロード
                  </Button>
                )}
              </div>
              <div className={`${css["sheetHeader__bar"]}`}></div>
              <div className={`${css["sheetHeader__side"]}`}>
                <IconButton
                  onClick={() => {
                    setOpen(false);
                  }}
                  sx={{
                    padding: 0,
                  }}
                >
                  <CloseIcon
                    sx={{
                      fontSize: iconSize,
                    }}
                  />
                </IconButton>
              </div>
            </div>
          </Sheet.Header>
          <Sheet.Content disableDrag={true}>
            <ContentType
              contentType={contentType}
              contentUrl={contentUrl}
              scrollPosition={scrollPosition}
              setscrollPosition={setscrollPosition}
            />
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={closeSheet} />
      </Sheet>
    </>
  );
};

const ContentWrapper = ({ children, transform = false }) => {
  return (
    <>
      {transform ? (
        <TransformWrapper>
          <TransformComponent
            wrapperStyle={{
              background: "#eeeeee",
              width: "100%",
              height: "100%",
            }}
            contentStyle={{
              // background: "rgb(231, 231, 255)",
              width: "100%",
              height: "100%",
            }}
          >
            <div className={`${css["sheetContentWrap"]}`}>{children}</div>
          </TransformComponent>
        </TransformWrapper>
      ) : (
        <div className={`${css["sheetContentWrap"]}`}>{children}</div>
      )}
    </>
  );
};

const NoResult = () => {
  return (
    <div className={`${css["notResult"]}`}>
      <ErrorOutlineIcon
        sx={{
          fontSize: 50,
        }}
      />
      <p className={`${css["noResultText"]}`}>
        表示するコンテンツが見つかりませんでした
      </p>
    </div>
  );
};

const ContentType = ({
  contentType,
  contentUrl,
  scrollPosition,
  setscrollPosition,
}) => {
  if (!contentUrl) {
    // console.log("No contentUrl");

    return (
      <ContentWrapper>
        <NoResult />
      </ContentWrapper>
    );
  }

  if (contentType?.includes("image")) {
    console.log("ContentType:", contentType, contentUrl);

    return (
      <ContentWrapper transform={true} contentUrl={contentUrl}>
        <div className={`${css["sheetContentWrap"]}`}>
          <img
            className={`${css["fullHeight"]} ${css["fullWidth"]}  ${css["object-fit"]}`}
            src={contentUrl}
            alt="image"
          />
        </div>
      </ContentWrapper>
    );
  } else if (contentType?.includes("video")) {
    return (
      <ContentWrapper>
        <div className={`${css["videoWrapper"]}`}>
          <p>動画が小さい場合は最大化させてご覧下さい。</p>
          <video
            className={`${css["fullWidth"]} ${css["object-fit"]}`}
            controls
            playsInline
            src={`${contentUrl}#t=0.001`}
          ></video>
        </div>
      </ContentWrapper>
    );
  } else if (contentType?.includes("pdf")) {
    return (
      <PdfContent
        contentUrl={contentUrl}
        scrollPosition={scrollPosition}
        setscrollPosition={setscrollPosition}
      />
    );
  } else {
    // console.log("iframe:", contentType, contentUrl);
    return (
      <ContentWrapper>
        <iframe
          className={`${css["fullHeight"]} ${css["fullWidth"]}`}
          src={contentUrl}
        ></iframe>
      </ContentWrapper>
    );
  }
};

const PdfContent = ({ contentUrl, scrollPosition, setscrollPosition }) => {
  const [numPages, setNumPages] = useState<number>();
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  const [showPager, setshowPager] = useState(true);
  const [containerWidth, setcontainerWidth] = useState<number>();
  const maxSize = 800;

  const maxScale = 500;
  const minScale = 25;
  const initialScalePercentage = 100;
  const [scale, setscale] = useState(initialScalePercentage);
  const [displayScale, setdisplayScale] = useState(initialScalePercentage);
  const [loading, setloading] = useState(true);
  const [init, setinit] = useState(false);

  const documentRef = useRef<React.Ref<HTMLDivElement>>(null);
  const footerRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    setdisplayScale(scale);
  }, [scale]);

  useEffect(() => {
    if (!loading) {
      documentRef.current?.addEventListener("scroll", scrollHandler);
    }

    return () => {
      documentRef.current?.removeEventListener("scroll", scrollHandler);
    };
  }, [loading]);

  const onResize = useCallback<ResizeObserverCallback>(
    (entries) => {
      if (!init) {
        setTimeout(() => {
          scrollToPrevPosition();
        }, 200);
        setinit(true);
      }

      let entry;
      if (entries) {
        entry = entries[0];
      }

      if (entry) {
        setcontainerWidth(entry.contentRect.width);
      }
    },
    [init]
  );

  useResizeObserver(containerRef, resizeObserverOptions, onResize);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
    setloading(false);
  }

  const togglePager = (e) => {
    // pagerを含んでなかったら非表示
    if (!e.target.closest(`#${footerRef.current.id}`)) {
      setshowPager((prev) => !prev);
    }
  };

  const changeScaleByBtn = (add: boolean | "reset") => {
    if (add === "reset") {
      setscale(initialScalePercentage);
    } else {
      setscale((prevPercentage) => {
        // 係数
        const value = add ? 25 : -25;
        const result = prevPercentage + value;

        if (result <= maxScale && result >= minScale) {
          return result;
        } else {
          return prevPercentage;
        }
      });
    }
  };

  const scrollHandler = (e) => {
    setscrollPosition((prev) => {
      let newArr = [...prev].filter((item) => {
        return item.contentUrl !== contentUrl;
      });
      newArr.push({
        contentUrl: contentUrl,
        scrollTop: documentRef.current?.scrollTop,
      });

      return newArr;
    });
  };

  // 以前にスクロールした位置まで戻す
  const scrollToPrevPosition = () => {
    const prevPosition = scrollPosition.find((item) => {
      return item.contentUrl === contentUrl;
    })?.scrollTop;

    if (prevPosition) {
      documentRef.current?.scrollTop = prevPosition;
    }
  };

  return (
    <div
      className={`${css["pdfWrapper"]}`}
      onClick={togglePager}
      style={{
        userSelect: "none",
      }}
    >
      <ContentWrapper>
        <div
          ref={setContainerRef}
          className={`${css["fullWidth"]} ${css["disableSelect"]}`}
        >
          <Document
            inputRef={documentRef}
            className={`${css["pdfDocument"]}`}
            file={contentUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            noData={<NoResult />}
          >
            <div className={`${css["padPageWrap"]}`}>
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  className={`${css["pdfPage"]} ${
                    index === 0 && css["pdfPage__topBorder"]
                  }`}
                  key={`page_${index + 1}`}
                  canvasRef={canvasRef}
                  pageNumber={index + 1}
                  onRenderSuccess={onResize}
                  scale={scale / 100}
                  width={
                    containerWidth
                      ? Math.min(containerWidth, maxSize)
                      : undefined
                  }
                />
              ))}
            </div>
          </Document>
        </div>
      </ContentWrapper>
      <div
        ref={footerRef}
        id="pdfPager"
        className={`${css["pager"]} ${showPager && css["isShow"]}`}
      >
        <IconButton
          onClick={() => {
            changeScaleByBtn(false);
          }}
        >
          <RemoveIcon
            sx={{
              fontSize: iconSize,
            }}
          />
        </IconButton>
        <div className={`${css["pagerNumContainer"]}`}>
          <IconButton
            onClick={() => {
              changeScaleByBtn("reset");
            }}
          >
            <ZoomInIcon
              sx={{
                fontSize: iconSize,
              }}
            />
          </IconButton>
        </div>

        <IconButton
          onClick={() => {
            changeScaleByBtn(true);
          }}
        >
          <AddIcon
            sx={{
              fontSize: iconSize,
            }}
          />
        </IconButton>
      </div>
    </div>
  );
};

export default SheetUrl;
